export default "__VITE_ASSET__WJxAOhua__"